import PlantelsListLayer from "../../components/PlantelsListLayer";

const PlantelsPage = () => {
  return <PlantelsListLayer />;
};

export default PlantelsPage;
